<template>
	<div class="details-unit__container">
		<div :style="{background: this.titleBackground}" class="details-unit__header"
			 @click="this.isOpened = !this.isOpened">
			<h5 :style="{color: this.titleColor}">{{ this.title }}</h5>
			<i v-if="!this.isOpened" class="fa-solid fa-chevron-down"></i>
			<i v-if="this.isOpened" class="fa-solid fa-chevron-up"></i>
		</div>

		<Transition name="slide-fade">
			<div v-if="this.isOpened" :style="{color: this.contentTextColor, background: this.contentBackground }" class="details-unit__content">
				<template v-for="item in this.convertedHtmlArray(this.content, this.modules.forms, this.modules.documents)">
					<template v-if="item.hasOwnProperty('type')">
						<inline-document v-if="item.type === InlineModuleTypeEnum.DOCUMENT" :item="item.items"/>
						<inline-form v-if="item.type === InlineModuleTypeEnum.FORM" :item="item.items"/>
					</template>
					<p v-else v-html="item"></p>
				</template>
			</div>
		</Transition>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import InlineForm from "../InlineForm.vue";
import InlineDocument from "../InlineDocument.vue";
import {InlineModuleTypeEnum} from "../../Views/PageView/Enums/InlineModuleTypeEnum";
import {InlineModuleMixin} from "../../Mixins/InlineModuleMixin";
import {InlineModuleInterface} from "../../Views/PageView/Interfaces/Components/InlineModuleInterface";

export default defineComponent({
	name: "DetailsUnit",
	mixins: [InlineModuleMixin],
	computed: {
		InlineModuleTypeEnum() {
			return InlineModuleTypeEnum
		}
	},
	components: {InlineDocument, InlineForm},
	props: {
		title: {
			type: String,
			required: true,
			default: "",
		},
		content: {
			type: String,
			required: true,
			default: "",
		},
		titleColor: {
			type: String,
			required: true,
			default: "black",
		},
		titleBackground: {
			type: String,
			required: true,
			default: "white",
		},
		contentBackground: {
			type: String,
			required: true,
			default: "white",
		},
		contentTextColor: {
			type: String,
			required: true,
			default: "black",
		},
		modules: {
			type: Object as PropType<InlineModuleInterface>,
			required: true,
		}
	},
	data() {
		return {
			isOpened: false,
		}
	},
});
</script>

<style scoped>
</style>
